import { render, staticRenderFns } from "./VehicleProvisionReportStatistics.vue?vue&type=template&id=cc2298fc&"
import script from "./VehicleProvisionReportStatistics.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionReportStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem,QInput,QIcon,QField,QCheckbox} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QInput,QIcon,QField,QCheckbox}, component.options.components || {})
